import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_REQUESTFORPROPOSAL } from "../../../../utils/constants";
import { RFPInterface } from "../../../../models/ProcurementModule/RequestForProposal";
import RFPService from "../../../../services/procurementService/RFPService";

interface DeleteRFP {
  previousRFP: RFPInterface[];
  deletedPR: RFPInterface | undefined;
}

const useDeleteRFP = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, string, DeleteRFP>({
    mutationFn: RFPService.Remove,

    onMutate: (dataId: string) => {
      const previousRFP =
        queryClient.getQueryData<RFPInterface[]>([
          CACHE_KEY_REQUESTFORPROPOSAL,
          page,
          pageSize,
        ]) || [];

      queryClient.setQueryData<RFPInterface[]>(
        [CACHE_KEY_REQUESTFORPROPOSAL, page, pageSize],
        previousRFP.filter((data) => data.id !== dataId)
      );

      return {
        previousRFP,
        deletedPR: previousRFP.find((data) => data.id === dataId),
      };
    },

    onError: (error, dataId, context) => {
      if (!context) return;

      queryClient.setQueryData<RFPInterface[]>(
        [CACHE_KEY_REQUESTFORPROPOSAL, page, pageSize],
        context.previousRFP
      );
    },

    onSuccess: () => {
      // Optionally, you could perform additional actions on success
      // For example, invalidating queries or updating other parts of the state
    },
  });
};

export default useDeleteRFP;
